import { actionTypeRapportMakuleringer } from "../../actions/rapporter/makuleringerActions";
import { CreateNewReducer } from "../../utils/reducerUtils";

const initialState = [];
const makuleringerRapportReducer = (state = [...initialState], action) =>
  CreateNewReducer(state, action, actionTypeRapportMakuleringer);

export default makuleringerRapportReducer;
